export default __webpack_public_path__ + "static/media/mario12.bfd66b81.jpg";